import { CreateCert, RenderCert } from '../components';
import { Tabs, Typography } from 'antd';
import { PlusOutlined, SafetyCertificateOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Certifications = () => {
  const tabItems = [
    {
      key: 'view',
      label: (
        <span className="flex items-center space-x-2">
          <SafetyCertificateOutlined />
          <span>My Certificates</span>
        </span>
      ),
      children: <RenderCert />,
    },
    {
      key: 'create',
      label: (
        <span className="flex items-center space-x-2">
          <PlusOutlined />
          <span>Add Certificate</span>
        </span>
      ),
      children: <CreateCert />,
    },
  ];

  return (
    <div className="min-h-screen bg-bg-primary">
      {/* Page Header */}
      <div className="bg-white border-b border-border-light">
        <div className="max-w-7xl mx-auto px-6 py-8">
          <div className="flex items-center space-x-3">
            <SafetyCertificateOutlined className="text-3xl text-accent-blue" />
            <div>
              <Title level={1} className="m-0 text-text-primary font-bold">
                Certifications
              </Title>
              <p className="text-text-secondary mt-1 text-lg">
                Manage your professional certifications and credentials
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Content */}
      <div className="max-w-7xl mx-auto px-6 py-8">
        <Tabs
          defaultActiveKey="view"
          items={tabItems}
          size="large"
          className="tabs"
        />
      </div>

      
    </div>
  );
};

export default Certifications;